/* eslint-disable no-unused-vars, no-undef */

// QuantityInput web component for rebrand product pages.
// global.js skips defining it on product pages, and sleepdoctor-main-product.js
// (which does define it) isn't loaded when product_layout == 'rebrand', so we
// register it here to power the rebrand qty pill's +/- buttons.
if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor () {
      super()
      this.input = this.querySelector('input')
      this.changeEvent = new Event('change', { bubbles: true })
      if (this.input) {
        this.input.addEventListener('change', this.onInputChange.bind(this))
      }
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      )
    }

    connectedCallback () {
      this.validateQtyRules()
    }

    onInputChange () {
      this.validateQtyRules()
    }

    onButtonClick (event) {
      event.preventDefault()
      const previousValue = this.input.value
      if (event.target.name === 'plus') {
        this.input.stepUp()
      } else {
        this.input.stepDown()
      }
      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent)
      }
    }

    validateQtyRules () {
      if (!this.input) return
      const value = parseInt(this.input.value)
      if (this.input.min) {
        const buttonMinus = this.querySelector(".quantity__button[name='minus']")
        if (buttonMinus) buttonMinus.classList.toggle('disabled', value <= parseInt(this.input.min))
      }
      if (this.input.max) {
        const buttonPlus = this.querySelector(".quantity__button[name='plus']")
        if (buttonPlus) buttonPlus.classList.toggle('disabled', value >= parseInt(this.input.max))
      }
    }
  }
  customElements.define('quantity-input', QuantityInput)
}

// Variant-change price sync.
//
// VariantSelects.onVariantChange in global.js calls `window.updatePrices(...)`
// before the sync flag is set, and that path is the one legacy layouts use.
// (The PUB_SUB variantChange/optionValueSelectionChange events are gated behind
//  `!syncInProgress`, but syncOtherVariantSelects sets that flag synchronously
//  and only clears it via a 100ms setTimeout, so subscribing to those events
//  on a page with both a main and sticky variant-selects is a dead-end.)
//
// sleepdoctor-main-product.js defines window.updatePrices for legacy markup,
// but it isn't loaded on rebrand pages, so define our own that targets the
// .sd-main-product-rebrand__price-* wrappers.
;(function () {
  function formatPriceCents (cents) {
    if (cents === null || cents === undefined || cents === '') return ''
    const n = typeof cents === 'string' ? parseInt(cents, 10) : cents
    if (Number.isNaN(n)) return ''
    const dollars = Math.floor(n / 100)
    const remainderCents = n % 100
    const formatted = '$' + dollars.toLocaleString('en-US')
    return remainderCents === 0
      ? formatted
      : formatted + '.' + remainderCents.toString().padStart(2, '0')
  }

  window.updatePrices = function (price, comparePrice, isAvailable) {
    if (price === null || price === undefined) return

    const priceN = typeof price === 'string' ? parseInt(price, 10) : price
    const compareN = comparePrice && (typeof comparePrice === 'string' ? parseInt(comparePrice, 10) : comparePrice)
    const formattedPrice = formatPriceCents(priceN)

    document.querySelectorAll('.sd-main-product-rebrand__price-current').forEach(function (el) {
      el.textContent = formattedPrice
    })

    document.querySelectorAll('.sd-main-product-rebrand__price-compare').forEach(function (el) {
      if (compareN && compareN > priceN) {
        el.textContent = formatPriceCents(compareN)
        el.hidden = false
        el.style.removeProperty('display')
      } else {
        el.hidden = true
        el.style.display = 'none'
      }
    })

    document.querySelectorAll('.sd-main-product-rebrand__sale-tag').forEach(function (el) {
      if (compareN && compareN > priceN) {
        const pct = Math.round(((compareN - priceN) / compareN) * 100)
        el.textContent = pct + '% Off'
        el.hidden = false
        el.style.removeProperty('display')
      } else {
        el.hidden = true
        el.style.display = 'none'
      }
    })
  }
})()

document.addEventListener('DOMContentLoaded', function () {
  // ---- Mobile Swiper Gallery ----
  const mobileGalleries = document.querySelectorAll('[id^="rsp-gallery-mobile-"]')
  mobileGalleries.forEach(function (gallery) {
    if (window.innerWidth < 750 && typeof Swiper !== 'undefined') {
      new Swiper('#' + gallery.id, { // eslint-disable-line no-new
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '#' + gallery.id + ' .swiper-pagination',
          clickable: true
        }
      })
    }
  })

  // ---- Desktop Thumbnail Gallery ----
  const desktopGalleries = document.querySelectorAll('.sd-main-product-rebrand__gallery-desktop')
  desktopGalleries.forEach(function (gallery) {
    const thumbs = gallery.querySelectorAll('.sd-main-product-rebrand__thumb')
    const prevBtn = gallery.querySelector('.sd-main-product-rebrand__nav--prev')
    const nextBtn = gallery.querySelector('.sd-main-product-rebrand__nav--next')
    let currentIndex = 0

    const mainMediaContainer = gallery.querySelector('.sd-main-product-rebrand__main-image')

    function updateMainMedia (thumb) {
      const mediaType = thumb.dataset.mediaType || 'image'
      const currentEl = mainMediaContainer ? mainMediaContainer.querySelector('img, video') : null
      if (!currentEl || !mainMediaContainer) return

      if (mediaType === 'video') {
        if (currentEl.tagName === 'VIDEO') {
          currentEl.src = thumb.dataset.videoUrl
          currentEl.poster = thumb.dataset.videoPoster || ''
          currentEl.load()
          currentEl.play()
        } else {
          const videoEl = document.createElement('video')
          videoEl.id = currentEl.id
          videoEl.src = thumb.dataset.videoUrl
          videoEl.poster = thumb.dataset.videoPoster || ''
          videoEl.width = currentEl.width || 600
          videoEl.height = currentEl.height || 600
          videoEl.controls = true
          videoEl.loop = true
          videoEl.playsInline = true
          videoEl.preload = 'none'
          currentEl.replaceWith(videoEl)
          videoEl.play()
        }
      } else {
        if (currentEl.tagName === 'IMG') {
          currentEl.src = thumb.dataset.imageUrl
          currentEl.alt = thumb.dataset.imageAlt || ''
        } else {
          const imgEl = document.createElement('img')
          imgEl.id = currentEl.id
          imgEl.src = thumb.dataset.imageUrl
          imgEl.alt = thumb.dataset.imageAlt || ''
          imgEl.width = currentEl.width || 600
          imgEl.height = currentEl.height || 600
          currentEl.pause && currentEl.pause()
          currentEl.replaceWith(imgEl)
        }
      }
    }

    const thumbsContainer = gallery.querySelector('.sd-main-product-rebrand__thumbnails')
    const thumbSize = 60
    const thumbGap = 8

    function calculateThumbsWidth () {
      if (!thumbsContainer) return
      const thumbCount = thumbs.length
      if (thumbCount === 0) return
      const mainImageEl = gallery.querySelector('.sd-main-product-rebrand__main-image')
      const maxWidth = mainImageEl ? mainImageEl.offsetWidth : 600
      const maxThumbs = Math.floor((maxWidth + thumbGap) / (thumbSize + thumbGap))
      const visibleThumbs = Math.min(thumbCount, maxThumbs)
      const exactWidth = (visibleThumbs * thumbSize) + ((visibleThumbs - 1) * thumbGap)
      thumbsContainer.style.width = exactWidth + 'px'
    }

    calculateThumbsWidth()
    window.addEventListener('resize', calculateThumbsWidth)

    function scrollThumbIntoView (index) {
      if (!thumbsContainer) return
      const currentScroll = thumbsContainer.scrollLeft
      const containerWidth = thumbsContainer.offsetWidth
      const thumbStart = index * (thumbSize + thumbGap)
      const thumbEnd = thumbStart + thumbSize

      if (thumbStart <= currentScroll + thumbSize && currentScroll > 0) {
        const newScroll = Math.max(0, thumbStart - thumbSize - thumbGap)
        thumbsContainer.scrollTo({ left: newScroll, behavior: 'smooth' })
      } else if (thumbEnd >= currentScroll + containerWidth - thumbSize) {
        thumbsContainer.scrollTo({ left: thumbStart, behavior: 'smooth' })
      }
    }

    function updateActiveThumb (activeThumb) {
      thumbs.forEach(function (t) {
        t.classList.remove('is-active')
      })
      activeThumb.classList.add('is-active')
      scrollThumbIntoView(currentIndex)
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        currentIndex = index
        updateMainMedia(thumb)
        updateActiveThumb(thumb)
      })
    })

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        currentIndex = (currentIndex - 1 + thumbs.length) % thumbs.length
        updateMainMedia(thumbs[currentIndex])
        updateActiveThumb(thumbs[currentIndex])
      })
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        currentIndex = (currentIndex + 1) % thumbs.length
        updateMainMedia(thumbs[currentIndex])
        updateActiveThumb(thumbs[currentIndex])
      })
    }
  })
})
/* eslint-enable no-unused-vars, no-undef */
